<template>
	<div class="basic_wrap" v-show="true">
		<!-- <div class="back_left" @click="$router.back()">
			<img src="../img/common/back_b.png">
		</div> -->
		<van-icon  class="back_left" color="#ffffff" size="20"  @click="$router.back()" name="arrow-left" />
		<div class="language" @click="$router.push('/language')">
			<img :src="language_logo">
			<div>{{ country_loc }}</div>

		</div>
		<div class="logo">
			<img :src="config.logo" />
				<!-- <img src="../img/user/usdt.png" /> -->
		</div>


		<div class="form_div" v-show="false">
			<form class="form">
				<div v-if="config.register_phone == 0" class="item">
					<input v-model.trim="data.username" type="text" class="inp" :placeholder="$t('login.username')">
				</div>
				<div v-if="config.register_phone == 1" class="item">
					<input v-model.trim="data.username" type="number" class="inp" :placeholder="$t('login.phone')">
				</div>
				<div v-if="config.register_phone == 2" class="item">
					<input v-model.trim="data.username" type="text" class="inp" :placeholder="$t('login.email')">
				</div>
				<div class="item">
					<input v-model.trim="data.password" :type="password" class="inp" :placeholder="$t('login.password')">
					<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
				</div>
				<div class="item">
					<input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('login.code')">
					<img style="height: 32px;margin-bottom: 8px;" :src="verify_img" @click="getVerifyCode()">
				</div>
				<div class="register_btn"
					:class="data.username == '' || data.password == '' || data.code == '' ? 'no_touch' : ''"
					@click="submit">
					→
				</div>
			</form>
		</div>

		<!-- 输入框部分 -->
		<div class="form_box">

			<div class="input_box">
				<div class="title">{{ $t('login.username') }}</div>
				<!-- 输入框部分 -->
				<!-- <input v-model.trim="data.username" v-on:blur="handleBlur" type="text" class="input_main"
					:placeholder="$t('login.email')"> -->
					<input v-model.trim="data.username" type="text" class="input_main" :placeholder="$t('login.username')">
			</div>



			<div class="input_box">
				<div class="title">{{ $t('login.password') }}</div>
				<!-- 输入框部分 -->
				<input v-model.trim="data.password" type="password" class="input_main" :placeholder="$t('login.password')">
			</div>

			<div class="input_box" v-if="googleStatus == 1">
				<div class="title">{{ $t('Google 验证码') }}</div>
				<!-- 输入框部分 -->
				<input v-model.trim="data.google_code" type="text" class="input_main" :placeholder="$t('Google 验证码')">
			</div>

			<!-- <div class="input_box_email">
				<div class="title">邮箱验证码</div>
				<div class="input_send_box"><input v-model.trim="data.username" type="text" class="input_main"
						placeholder="邮箱验证码" />
					<div class="input_send">发送验证码</div>
				</div>
			</div> -->

			<div class="input_box_email">
				<div class="title">{{ $t('login.code') }}</div>
				<!-- 输入框部分 -->
				<div class="input_send_box"><input v-model.trim="data.code" type="text" class="input_main"
						:placeholder="$t('login.code')" />
					<div class="input_code"><img :src="verify_img" @click="getVerifyCode()" /></div>
				</div>
			</div>


		</div>
		<!-- 登录按钮 -->
		<div class="loginBtnBox">
			<van-button @click="submit" class="bindBtn"
				:disabled="data.username == '' || data.password == '' || data.code == ''" type="primary" block>{{
					$t("login.txt1") }}</van-button>
		</div>


		<div class="to_register">{{ $t("login.txt2") }}<span @click="$router.push('/register')" class="register_btn">{{
			$t("login.txt3") }}</span></div>
		<!-- <div class="login_register">
			<router-link to="/register">
				<div>
					{{ $t('login.registerNow') }}
				</div>
			</router-link>
		</div> -->

		<div class="forget_pass" @click="showChangePass=true">{{ $t('忘记密码') }}?</div>
		<div class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../img/index/kefu.png">
		</div>


		<!-- 修改密码弹出框 -->
		<van-popup class="loginModel" v-model="showChangePass" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="title">{{ $t('忘记密码') }}</div>
				
				
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params.email"
						:placeholder="$t('login.email')" />
				</div>
				<!-- 验证邮箱 -->
				<div class="input_box_email111">
					<div class="input_send_box"><input v-model.trim="params.email_code" type="text" class="input_main"
							:placeholder="$t('login.txt4')" />

						<div class="input_send">
							<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
								<template v-slot="timeData">
									<span @click="sendcode">{{
										timeData.seconds > 0
										? timeData.seconds
										: $t('auth.sendEmailCode')
									}}</span>
								</template>
							</van-count-down>
						</div>
					</div>
				</div>
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params.newpwd"
						:placeholder="$t('user.txt7')" />
				</div>
				<!-- 绑定按钮 -->
				<div class="bindBtnBox">

					<van-button class="bindBtn" type="primary" @click="updataPass()" block>{{
						$t('user.save')
					}}</van-button>
				</div>
			</div>
		</van-popup>

	</div>
</template>

<script>
import Vue from "vue";
import bsHeader from '../../components/bsHeader.vue'
import {
	CountDown,
	Checkbox,
	Dialog
} from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown)
	.use(Checkbox)
	.use(Dialog);

export default {
	name: "login",
	components: {
		bsHeader
	},
	data() {
		return {
			country_loc: localStorage.getItem("country_loc") ? localStorage.getItem("country_loc") : 'English',
			logo: localStorage.getItem("logo2"),
			language_logo: localStorage.getItem('language_logo'),
			show_kefu: false,
			password: "password",
			loading: false,
			data: {
				username: "",
				password: "",
				code: "",
				google_code: ""
			},
			params: {
				newpwd: '',
				email_code: '',
				email: ''
			},
			config: {
				register_phone: 0
			},
			verify_img: "",
			googleStatus: 0,
			showChangePass: false,
			time: 0,
			is_send: false,
		};
	},
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FAFAFA');
			plus.navigator.setStatusBarStyle('dark');
		}
		this.$parent.footer("user", false);
	},

	mounted() {
		// if (this.$route.query.agent) {
		// 	localStorage.setItem('agent', this.$route.query.agent);
		// 	this.data.agent = this.$route.query.agent;
		// } else {
		// 	if (localStorage.getItem('agent')) {
		// 		this.data.agent = localStorage.getItem('agent');
		// 	}
		// }
		var that = this;
		document.body.addEventListener(
			"scroll",
			function () {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			},
			false
		);
		document.addEventListener(
			"click",
			function (ev) {
				if (ev.target.className != "kefu_img") {
					that.show_kefu = false;
				}
			},
			false
		);
		this.start();
		this.getVerifyCode();
	},
	methods: {
		timeCall() {
			this.is_send = false;
			this.time = 0;
		},
		sendcode() {
			if (this.is_send) {
				return false;
			}
			if (!this.params.email) {
				this.$toast(this.$t('auth.emailEmpty'));
				return false;
			}
			var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
			if (!reg.test(this.params.email)) {
				this.$toast(this.$t('auth.emailError'));
				return false;
			}
			this.is_send = true;

			Fetch("/index/getEmailCode", {
				email: this.params.email
			}).then(() => {
				this.time = 60 * 1000;
				this.$toast({
					background: "#07c160",
					message: this.$t('auth.sendsuccess'),
				});
			}).catch(() => {
				this.is_send = false;
			});
		},
		//忘记密码
		updataPass() {
			
			if (this.params.newpwd == "") {
				this.$toast(this.$t('user.txt10'));
				return;
			}
			Fetch('/index/findpwd', {
				...this.params,
			}).then(r => {
				this.showChangePass = false;
				this.params.newpwd = '';
				this.params.email_code = '';
				this.params.email = '';
				if (r.data.token) {
					localStorage.setItem('token', r.data.token);
				}
				this.$toast(this.$t('login.loginSuccess'));
				this.$router.replace("/");
				// this.$router.replace('/user');
			})
		},
		handleBlur() {
			this.checkgoogle();
			// 在这里可以执行你想要的操作
		},
		//验证账号是否已经google 验证过了
		checkgoogle() {
			if (this.data.username == '') {
				return;
			}
			//console.log('11111111111111',this.data.username);
			Fetch("/user/checkgoogle", {
				...this.data,
			}).then((res) => {
				this.googleStatus = res.data.status;
			}).catch((res) => {

			});

		},
		start() {
			Fetch("/index/getWebInfo").then((r) => {
				this.config = r.data;
			});
		},
		kefu_to() {
			if (this.show_kefu) {
				this.$router.push("/service");
			}
			this.show_kefu = !this.show_kefu;
		},
		showPwd() {
			if (this.password == "password") {
				this.password = "text";
			} else {
				this.password = "password";
			}
		},
		submit() {
			if (this.loading) {
				return false;
			}
			//数字、字母或下划线
			var reg1 = /^[0-9a-zA-Z_]{1,}$/;
			var reg2 = /^\w+([\.\-]\w+)*\@\w+([\.\-]\w+)*\.\w+$/
			//用户名注册判断
			if (this.config.register_phone == 0) {
				if (!this.data.username) {
					this.$toast(this.$t('login.usernameEmpty'));
					return false;
				}
				// if (!reg1.test(this.data.username)) {
				// 	this.$toast(this.$t('login.usernameLimit'));
				// 	return false;
				// }
				// if (this.data.username.length > 16 || this.data.username.length < 4) {
				// 	this.$toast(this.$t('login.usernameLength'));
				// 	return false;
				// }
			}
			//邮箱注册判断
			else if (this.config.register_phone == 2) {
				if (!this.data.username) {
					this.$toast(this.$t('login.emailEmpty'));
					return false;
				}
				// if (!reg2.test(this.data.username)) {
				// 	this.$toast(this.$t('login.emailError'));
				// 	return false;
				// }
			}
			//手机号注册判断
			else {
				if (!this.data.username) {
					this.$toast(this.$t('auth.phoneEmpty'));
					return false;
				}
				// if (this.data.username.length < 6 || this.data.username.length > 16) {
				// 	this.$toast(this.$t('auth.phoneError'));
				// 	return;
				// }
			}

			if (!this.data.password) {
				this.$toast(this.$t('login.passwordEmpty'));
				return false;
			}
			if (!reg1.test(this.data.password)) {
				this.$toast(this.$t('login.passwordLimit'));
				return false;
			}
			if (this.data.password.length > 16 || this.data.password.length < 6) {
				this.$toast(this.$t('login.passwordLength'));
				return false;
			}
			if (!this.data.code) {
				this.$toast(this.$t('login.codeEmpty'));
				return false;
			}
			this.loading = true;
			Fetch("/index/login", {
				...this.data,
			}).then((res) => {
				if (res.data.token) {
					localStorage.setItem('token', res.data.token);
				}
				this.$toast(this.$t('login.loginSuccess'));
				this.$router.replace("/");
			}).catch((res) => {
				this.getVerifyCode();
				this.loading = false;
			});
		},
		getVerifyCode() {
			Fetch("/index/captcha").then((r) => {
				this.verify_img = r.data.image;
			});
		}
	},
};
</script>

<style lang="less" scoped>
.loginModel {
	background: white;
	box-sizing: border-box;
	text-align: center;
	color: #ffffff;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
	padding: 0 28px;
	padding-top: 42px;
	padding-bottom: 28px;
}
.van-count-down{
	color: white;
}
.phoneLogin {
	.title {
		color: #0A0A27;
		font-weight: bold;
		font-size: 18px;
		text-align: center;
	}

	.phoneInputBox {
		.phoneInput {
			width: 100%;
			border-radius: 4px;
			background: none;
			background: #F5F6F8;
			height: 60px;
			border: 0px;
			line-height: 60px;
			padding-left: 16px;
			outline: none;
			margin-top: 20px;
			font-size: 14px;
			color: #0A0A27;
		}

		input::placeholder {
			font-weight: bold;
			opacity: 0.5;
			color: #333;
		}
	}


	.codeBox {
		display: flex;
		justify-content: space-between;
		margin-top: 20px;

		.codeInput {
			border-radius: 4px;
			background: none;
			background: #F5F6F8;
			height: 60px;
			border: 0px;
			line-height: 60px;
			padding-left: 16px;
			outline: none;
			font-size: 14px;
			color: #0A0A27;
			width: 100%;

			::-webkit-input-placeholder {
				color: #333333;
				font-size: 12px;
			}
		}

		.pic1 {
			margin-left: 8px;
			width: 130px;
		}

	}

	.bindBtnBox {

		.bindBtn {
			height: 38px;
			border-radius: 100px;
			margin-top: 44px;
			border-radius: 4px;
			background: #326CF6;

			.van-button__text {
				font-size: 14px;
				font-weight: 400;
				color: white;
			}
		}
	}

	.input_box_email111 {
		margin-top: 20px;

		.input_send_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 60px;
			background: #F5F6F8;
			margin-top: 15px;
			border-radius: 8px;


			.input_main {
				width: 100%;
				border-radius: 4px;
				background: none;
				height: 60px;
				border: 0px;
				line-height: 60px;
				padding-left: 16px;
				outline: none;
				font-size: 14px;
				color: #0A0A27;
			}

			input::placeholder {
				font-weight: bold;
				opacity: 0.5;
				color: #333;
			}


			.input_send {
				height: 100%;
				width: 150px;
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: #326CF6;
				border-radius: 0 8px 8px 0;
				color: white;
				font-size: 12px;
			}


		}

	}


	.btn {
		position: inherit;
	}
}

.forget_pass {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	color: #328CF1;
	font-size: 14px;
	cursor: pointer;

}

.loginBtnBoxno_touch {
	color: #328CF1;
}

.to_register {
	width: 100%;
	text-align: center;
	margin-top: 30px;
	color: #ffffff;
	font-size: 14px;
	font-weight: 500;
	margin-bottom: 30px;

	.register_btn {
		color: #326CF6;
		padding-left: 3px;
	}
}

.loginBtnBox {
	margin: 0 30px;

	.bindBtn {
		height: 38px;
		border-radius: 100px;
		margin-top: 44px;
		border-radius: 4px;
		background: #326CF6;

		.van-button__text {
			font-size: 14px;
			font-weight: 400;
			color: white;
		}
	}
}

.van-button--primary {
	border: none !important;
}

.input_box {
	margin: 0 30px;
	margin-top: 15px;

	.title {
		font-size: 14px;
		font-weight: 500;
		color: #ffffff;
	}

	.input_main {
		width: 100%;
		border: 0px;
		outline: none;
		background: none;
		padding: 15px;
		background-color: white;
		margin-top: 15px;
		border-radius: 8px;

		::-webkit-input-placeholder {
			color: #333333;
			font-size: 12px;
		}
	}
}

.input_box_email {
	margin: 0 30px;
	margin-top: 15px;

	.title {
		font-size: 14px;
		font-weight: 500;
		color: #ffffff;
	}

	.input_send_box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 40px;
		background-color: white;
		margin-top: 15px;
		border-radius: 8px;


		.input_main {
			width: 100%;
			border: 0px;
			outline: none;
			background: none;
			background-color: white;
			font-size: 12px;
			padding: 0 15px;

			::-webkit-input-placeholder {
				color: #333333;
				font-size: 12px;
			}
		}

		.input_send {
			height: 100%;
			width: 120px;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #326CF6;
			border-radius: 0 8px 8px 0;
			color: white;
			font-size: 12px;
		}

		.input_code {
			img {
				width: 100%;
				height: 40px;
				border-radius: 0 8px 8px 0;
			}
		}
	}

}

.basic_wrap {
	position: relative;

}

.form_div {
	height: 600px;
	width: 100%;
	background: url(../img/user/login_background.png) no-repeat center center;
	background-size: 150% 100%;
	position: relative;
	top: -88px;

	.form {
		position: absolute;
		margin: 200px auto 0 5%;
		width: 90%;

		.register_btn {
			background: #68326C;
			color: #FFFFFF;
			width: 60px;
			height: 60px;
			border-radius: 50%;
			float: right;
			margin-right: 3%;
			text-align: center;
			line-height: 60px;
			font-size: 36px;
			font-weight: bold;
		}
	}
}

.back_left {
	background: unset;

	img {
		width: 20px;
		position: fixed;
		top: 10px;
		left: 10px;
	}
}

.language {
	position: absolute;
	top: 10px;
	right: 6px;
	height: 30px;
	z-index: 11;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	color: #ffffff;

	img {
		height: 100%;
	}
}

.logo {
	margin: 50px 0 0 30px;

	img {
		height: 80px;
	}
}

.item {
	height: 50px;
	font-size: 14px;
	display: flex;
	justify-content: flex-start;
	align-items: flex-end;
	padding-bottom: 4px;
	background: #FFFFFF;
	margin-bottom: 15px;
	border-radius: 25px;
	padding: 0 20px;

	input {
		height: 50px;
		flex: 1;
	}

	.get_captcha {
		line-height: 50px;
	}

	.eye_bi {
		margin-bottom: 12px;
	}
}

.sms_verify {
	padding: 20px 20px 0 20px;

	input {
		margin-top: 15px;
		height: 20px;
		font-size: 16px;
		width: 100%;
	}

	.btn {
		margin-top: 15px;
		justify-content: space-around;
		color: #ee0a24;
		height: 48px;
		font-size: 16px;
		border-top: 1px solid #ebedf0;

		div {
			width: 50%;
			text-align: center;
		}

		div:nth-child(1) {
			border-right: 1px solid #ebedf0;
		}
	}
}

.login_register {
	position: relative;
	top: -60px;
	font-size: 14px;
	margin-left: 50px;
}

/deep/ .van-dropdown-menu__bar {
	background-color: unset;
	box-shadow: unset;
	height: 50px;
	margin-right: 10px;
}

/deep/ .van-popup--top {
	left: 5%;
	width: 30%;
}
</style>
